import { CursorSelectIcon, PolygonIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

interface DrawSubToolPopupProps {
  drawMode: string;
  enterSelectMode: () => void;
  enterDrawMode: () => void;
  showLegendInfo?: boolean;
}

export const DrawSubToolPopup = ({
  drawMode,
  enterSelectMode,
  enterDrawMode,
  showLegendInfo
}: DrawSubToolPopupProps) => {
  return (
    <div
      className={twMerge(
        "absolute h-fit max-h-[75%] border-gainsboro right-24 z-50 bg-white px-2 rounded-lg overflow-auto p-2 shadow-md",
        showLegendInfo ? "z-[51] bottom-[362px]" : "bottom-[305px]"
      )}
    >
      <div className="flex flex-col gap-2 items-start">
        <button
          className={twMerge(
            "flex gap-2 font-semibold",
            drawMode === "simple_select"
              ? "text-teal-500 fill-teal-500"
              : "text-txtBody fill-txtBody"
          )}
          onClick={enterSelectMode}
        >
          <CursorSelectIcon width={16} height={16} />
          Select
        </button>
        <button
          className={twMerge(
            "flex gap-2 font-semibold",
            drawMode === "draw_polygon"
              ? "text-teal-500 fill-teal-500"
              : "text-txtBody fill-txtBody"
          )}
          onClick={enterDrawMode}
        >
          <PolygonIcon width={16} height={16} />
          Polygon
        </button>
      </div>
    </div>
  );
};
